<!-- 
AddToGroupNewModal.vue
功能：加入現有群組視窗
作者：i9400538 陳博承
完成：2021-05-21
-->
<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog w-900">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="text-green m-0 mt-1">編輯群組</h3>
        </div>
        <div class="modal-body">
          <div class="row mt-2 mb-4">
            <div class="col-12">
              <span v-if="custName" class="cust-name">
                請選擇&nbsp;
                <span class="text-green">{{custName}}</span> 想加入的群組
              </span>
              <span v-else class="cust-name">請選擇該客戶想加入的群組</span>
              <br />
              <br />
              <form class="form">
                <div class="input-group input-lg">
                  <div class="input">
                    <input
                      type="text"
                      id="keyword-Group"
                      class="form-control"
                      v-model="keyword"
                      placeholder="可輸入群組名稱進行搜尋..."
                      alt="ch"
                      maxlength="20"
                    />
                    <span v-show="keyword!==''" id="searchclear" @click="doClean()">清除</span>
                  </div>
                  <button
                    class="btn btn-primary btn-icon"
                    type="button"
                    @click.stop.prevent="doSearch()"
                  >
                    <i class="icon-search i-24"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="radio radio-inline">
                <input type="radio" v-model="selectType" id="selectType1" value="1" />
                <label @click="clickLabel('1')">可選擇</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" v-model="selectType" id="selectType2" value="2" />
                <label @click="clickLabel('2')">已加入 ({{selectedlist.length}})</label>
              </div>
            </div>
          </div>

          <div class="row row-tables newTable">
            <div class="col-table pr-0" v-show="selectType==='1'">
              <table id="unselected-group-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th width="90">#</th>
                    <th @click="sortArray('unselected','text')">群組名稱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in unselectedGroup" :key="`unselected-group-${type}-${i}`">
                    <td width="90">
                      <div class="checkbox checkbox-inline">
                        <input
                          type="checkbox"
                          :id="`unselected-check-group-${type}-${i}`"
                          :value="item"
                          v-model="selectedlist"
                          @click="addItem(item)"
                        />
                        <label :for="`unselected-check-group-${type}-${i}`"></label>
                      </div>
                      <span class="no">{{i + 1}}</span>
                    </td>
                    <td v-text="`${item.grp_name}`"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="px-2 text-light-green text-center col-split">
              <i class="icon-forward"></i>
            </div>
            <div class="col-table" v-show="selectType==='2'">
              <table id="selected-group-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th width="90">#</th>
                    <th @click="sortArray('selected','text')">群組名稱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in showList" :key="`selected-group-${type}-${i}`">
                    <td width="90">
                      <div class="checkbox checkbox-inline">
                        <input
                          type="checkbox"
                          :id="`selected-check-group-${type}-${i}`"
                          :value="item"
                          v-model="selectedlist"
                          @click="removeItem(item, i)"
                        />
                        <label :for="`selected-check-group-${type}-${i}`"></label>
                      </div>
                      <span class="no">{{i + 1}}</span>
                    </td>
                    <td v-text="`${item.grp_name}`"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="cancel()" class="btn btn-default">取消</a>
                <a @click="$emit('submit', selectedlist)" class="btn btn-primary">儲存</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "AddToGroupNewModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custName: {
      type: String,
      dafault: ""
    },
    allGroup: {
      type: Array
    },
    selectedGroup: {
      type: Array
    },
    type: {
      type: String,
      default: ""
    }
  },
  watch: {
    selectedGroup: function() {
      this.registerHanlink();
    },
    unselectedGroup: function() {
      this.registerHanlink();
    },
    selectedlist: function() {
      this.registerHanlink();
      if (this.selectedlist.length == 11) {
        this.selectedlist.splice(10, 1);
        this.showList.splice(10, 1);
        this.$toast.info({ title: "每個人不可超過10個群組" });
      }
    },
    open: function(val) {
      if (val == true) {
        this.unselectedGroup = [...this.allGroup];
        this.selectedlist = [...this.selectedGroup];
        this.showList = [...this.selectedGroup];
        this.keyword = "";
        this.init();
      }
    },
    selectType: "changeType",
    keyword: "changeKeyword"
  },
  data() {
    return {
      keyword: "",
      selectedlist: [],
      unselectedGroup: [],
      unselectedSort: true,
      selectedSort: true,
      unselectedItem: "text",
      selectedItem: "text",
      selectType: "1",
      showList: [] //已選擇區塊顯示用
    };
  },
  methods: {
    doClean() {
      this.keyword = "";
    },
    doSearch() {
      if (this.selectType === "1") {
        //搜尋全部區塊
        if (this.keyword.trim() != "") {
          this.unselectedGroup = this.allGroup.filter(item => {
            const t = item.grp_name.toUpperCase();
            const s = this.keyword.toUpperCase();
            return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
          });
        } else {
          this.unselectedGroup = [...this.allGroup];
        }
      } else {
        //搜尋已選擇區塊
        if (this.keyword.trim() !== "" && this.selectedlist.length > 0) {
          this.showList = this.selectedlist.filter(item => {
            const t = item.grp_name.toUpperCase();
            const s = this.keyword.toUpperCase();
            return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
          });
        } else {
          //顯示現有已選擇資料
          this.showList = [...this.selectedlist];
        }
      }
    },
    ToDBC(str) {
      //  半形轉化為全形
      var result = "";
      var len = str.length;
      for (var i = 0; i < len; i++) {
        var cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        cCode = cCode >= 0x0021 && cCode <= 0x007e ? cCode + 65248 : cCode;
        //處理空格
        cCode = cCode == 0x0020 ? 0x03000 : cCode;
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    // 排序陣列
    sortArray(arrayName, arrayPorp = "text") {
      if (arrayName === "unselected") {
        if (this.unselectedSort && this.unselectedItem === arrayPorp) {
          this.unselectedSort = !this.unselectedSort;
          this.unselectedGroup = this.unselectedGroup.sort(function(a, b) {
            return b[arrayPorp] >= a[arrayPorp] ? 1 : -1;
          });
        } else {
          this.unselectedItem = arrayPorp;
          this.unselectedSort = true;
          this.unselectedGroup = this.unselectedGroup.sort(function(a, b) {
            return a[arrayPorp] >= b[arrayPorp] ? 1 : -1;
          });
        }
      } else if (arrayName === "selected") {
        if (this.selectedSort && this.selectedItem === arrayPorp) {
          this.selectedSort = !this.selectedSort;
          this.selectedlist = this.selectedlist.sort(function(a, b) {
            return b[arrayPorp] >= a[arrayPorp] ? 1 : -1;
          });
          this.showList = this.showList.sort(function(a, b) {
            return b[arrayPorp] >= a[arrayPorp] ? 1 : -1;
          });
        } else {
          this.selectedItem = arrayPorp;
          this.selectedSort = true;
          this.selectedlist = this.selectedlist.sort(function(a, b) {
            return a[arrayPorp] >= b[arrayPorp] ? 1 : -1;
          });
          this.showList = this.showList.sort(function(a, b) {
            return a[arrayPorp] >= b[arrayPorp] ? 1 : -1;
          });
        }
      }
    },
    cancel() {
      this.selectType = "1";
      this.$emit("close");
    },
    changeType() {
      if (this.keyword.trim() !== "") {
        this.keyword = "";
      }
    },
    changeKeyword() {
      //檢查輸入欄位
      this.keyword = this.cleanSpecialChar(this.keyword, '@()_');
      if (this.stringBytes(this.keyword, false, 100) > 100) {
        this.keyword = this.keyword.substring(
          0,
          this.stringBytes(this.keyword, true, 100)
        );
      }

      if (this.keyword === "") {
        if (
          this.unselectedGroup &&
          this.unselectedGroup.length != this.allGroup.length
        ) {
          this.unselectedGroup = [...this.allGroup];
        }
        this.showList = [...this.selectedlist];
      }
    },
    clickLabel(val) {
      if (this.selectType === val) {
        return;
      }
      this.selectType = val;
    },
    addItem(item) {
      let findIndex = this.showList.indexOf(item);
      if (findIndex === -1) {
        this.showList.push(item);
      } else {
        this.showList.splice(findIndex, 1);
      }
    },
    removeItem(item, index) {
      let findIndex = this.selectedlist.indexOf(item);
      if (findIndex !== -1) {
        this.selectedlist.splice(findIndex, 1);
      }
      this.showList.splice(index, 1);
    },
    //初始化
    init() {
      this.unselectedGroup = this.allGroup.sort(function(a, b) {
        return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();
      });
      this.showList = this.selectedGroup
        .map(item => item)
        .sort(function(a, b) {
          return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.row.row-tables {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: table;
  > * {
    position: relative;
    display: table-cell;
  }
  .col-table {
    width: 100% !important;
  }
  .icon-forward {
    visibility: hidden;
  }
}

#searchclear {
  position: absolute;
  right: 25px;
  top: 14px;
  bottom: 0;
  margin-right: 58px;
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: green;
}

.w-900 {
  width: 900px;
}
.cust-name {
  font-size: 18px;
  font-weight: 600;
}
</style>